var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.isVisible
      ? _c(
          "div",
          {
            staticClass: "notification-screen problem-screen",
            on: { click: _vm.toggleProblemScreen }
          },
          [
            _c("div", { staticClass: "notification-screen-box" }, [
              _c(
                "div",
                { staticClass: "floating-container" },
                [
                  _c("jLottie", {
                    staticClass: "animation",
                    attrs: {
                      options: _vm.defaultOptions,
                      height: 250,
                      width: 250
                    },
                    on: { animCreated: _vm.handleAnimation }
                  }),
                  _vm._v(" "),
                  _c("h1", { staticClass: "title" }, [
                    _vm._v("\n          Problem\n        ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "h2",
                    {
                      staticClass: "message code m__b--0",
                      on: { click: _vm.click }
                    },
                    [_vm._v(_vm._s(_vm.code))]
                  ),
                  _vm._v(" "),
                  _vm.isMessageArray
                    ? _c(
                        "h2",
                        {
                          staticClass: "message m__t--5",
                          attrs: { id: "problem-screen-message" }
                        },
                        _vm._l(_vm.message, function(item, index) {
                          return _c("div", { key: index }, [
                            _vm._v(
                              "\n            " + _vm._s(item) + "\n          "
                            )
                          ])
                        })
                      )
                    : _c(
                        "h2",
                        {
                          staticClass: "message m__t--5",
                          attrs: { id: "problem-screen-message" }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.message) + "\n        "
                          )
                        ]
                      )
                ],
                1
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52213d52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52213d52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notification-screen/jProblemScreen.vue
// module id = null
// module chunks = 